<template>
  <section class="pa-3 hero pa-md-10">
    <v-row>
        <v-col cols="6" lg="6" md="6" class="mx-auto">
          <div class="login-form">
            <div class="separator"><h3 class="text-center mb-8">{{ $t("auth.login") }}</h3></div>
            <v-form ref="form" lazy-validation>
              <v-row>
                <v-col cols="10" lg="10" md="10" class="mx-auto">
                  <p style="text-align:center;color:red">{{ errorMsg }}</p>
                  <v-text-field v-model="form.email" :rules="emailRules" :label="$t('auth.email')" outlined filled append-icon="mdi-envelop"></v-text-field>
                  <v-text-field v-model="form.password" type="password" :rules="passwordRules" :label="$t('auth.password')" outlined filled append-icon="mdi-envelop" ></v-text-field>
                  <a href="/reset/password">{{ $t("auth.forgetPassword") }} ?</a>
                  <!-- <v-btn text class="primary my-8" :to="{name: 'resetPassword'}">{{ $t("auth.login") }}</v-btn> -->
                  <div>
                    <v-btn large block class="primary my-8" @click="handleLogin">{{ $t("auth.login") }}</v-btn>
                  </div>
                  <div class="my-5">{{ $t("auth.dontHaveAccount") }} ?
                    <router-link to="/auth/signup" class="font-weight-bold">{{ $t("auth.create") }}</router-link>
                  </div>
                </v-col>
              </v-row>
            </v-form>

            <v-row>
              <v-col cols="10" lg="10" md="10" class="mx-auto">
                <div class="separator">{{$t('or')}}</div>
                <fb-signin-button
                  class="btn-facebook-signin"
                  :params="fbSignInParams"
                  @success="onSignInSuccess"
                  @error="onSignInError">
                  <v-icon class="mr-3" style="color:#fff">mdi-facebook</v-icon> {{$t('sign_in_with_facebook')}}
                </fb-signin-button>
                <g-signin-button
                  class="btn-google-signin"
                  :params="googleSignInParams"
                  @success="ongSignInSuccess"
                  @error="ongSignInError">
                  <v-icon class="mr-3" style="color:#fff">mdi-google</v-icon> {{$t('sign_in_with_google')}}
                </g-signin-button>
              </v-col>
            </v-row>
          </div>
        </v-col>
    </v-row>
  </section>
</template>
<script>
import { mapActions , mapMutations} from "vuex";
export default {
  name: 'Home',

  data() {
    return {
      errorMsg: '',
      form: {
        email: '',
        password: ''
      },
      fbSignInParams: {
        scope: 'email',
        return_scopes: true
      },
      googleSignInParams: {
        client_id: '557097055911-1ovqacvc5ccu1gphd5aica9nbjpskn03.apps.googleusercontent.com'  
      },
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid email.',
      ],
      passwordRules: [
        v => !!v || 'Password is required'
      ],
    };
  },

  methods: {
    ...mapActions(["login", "register"]),

    onSignInSuccess (response) {
      const _this = this;

      FB.api('/me?fields=email,name', dude => {
        let payload = {
          'name': dude.name,
          'email': dude.email,
          'email_verify': true,
          'type': 3,
          'password': 'gisabosocial'
        };

        console.log(payload)
        console.log(dude)
        _this.handleSocial(payload);
      })

    },
    onSignInError (error) {
      this.loginErrors = "Error occured durring facebook login."
      console.log('OH NOES', error)
    },
    ongSignInSuccess (googleUser) {
      const profile = googleUser.getBasicProfile() // etc etc
      console.log(profile.getEmail());
      let payload = {
        'name': profile.getName(),
        'email': profile.getEmail(),
        'email_verify': true,
        'type': 3,
        'password': 'gisabosocial'
      };

      console.log(payload)
      console.log(profile)
      this.handleSocial(payload);
    },
    ongSignInError (error) {
      this.loginErrors = "Error occured durring facebook login."
      console.log('OH NOES', error)
    },
    async handleSocial(payload) {
      let status = await this.login(payload)
      
      if(status.access_token) {
        window.location.reload()
      } else {
        let st = await this.register(payload)
        if(st.access_token) {
          let status = await this.login(payload)
          if(status.access_token) {
            window.location.reload()
          }
        }
      }
    },
    async handleLogin () {
      let validate = this.$refs.form.validate()
      if(validate) {
        let data = await this.login(this.form)
        console.log(data)

        if(data.access_token) {
          window.location.reload()
        } else {
          this.errorMsg = data.errors.email.join('<br/>')
        }
      }
    }
  },
  mounted() {
    if(window.localStorage.getItem('token') !== null) {
      this.$router.push(window.localStorage.getItem('previous'))
    }
  }
}
</script>
<style scoped>
.hero {
  background-size: cover;
}

.login-form {
  border: 2px solid rgb(35, 35, 104);
  padding: 5px;
  border-radius: 20px;
}

.v-text-field--outlined >>> fieldset {
  border-color: black;
}

.btn-facebook-signin{
  border-radius: 5px;
  width: 100%;
  display: block;
  font-weight: 600;
  font-size: 16px;
  margin: 5px 2px;
  box-sizing: border-box;
  border-width: 2px;
  background-color: #3c66c4;
  border-color: #ce3333;
  color: #fff;
  padding: 10px;
}
.btn-google-signin {
  border-radius: 5px;
  width: 100%;
  display: block;
  font-weight: 800;
  font-size: 16px;
  box-sizing: border-box;
  border-width: 2px;
  margin: 5px 2px;
  background-color: #ce3333;
  border-color: #ce3333;
  color: #fff;
  padding: 10px;
}

.separator {
  display: flex;
  align-items: center;
  text-align: center;
}

.separator::before,
.separator::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #000;
}

.separator:not(:empty)::before {
  margin-right: .25em;
}

.separator:not(:empty)::after {
  margin-left: .25em;
}
</style>
